<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: vertical.vue
  - Created by: Kevin
  - Create Date: 2023-01-03 13:33
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<script>
import {layoutComputed} from "@/state/helpers";
import ProfileData from "@/utils/cookie/ProfileData";

import NavBar from "@/components/nav-bar.vue";
import SideBar from "@/components/side-bar.vue";
import RightBar from "@/components/right-bar.vue";
import Footer from "@/components/footer.vue";
import router from "@/router";

/**
 * Vertical layout
 */
export default {
  components: {NavBar, SideBar, RightBar, Footer},
  data() {
    return {
      type: this.$store ? this.$store.state.layout.leftSidebarType : null,
    };
  },
  computed: {
    ...layoutComputed,
    hideLayout() {
      return this.$route.meta.hideLayout === true;
    },
  },
  mounted() {
    // 这里原本还给 `this.$refs.sideBar.menu` 赋 theme / backgroundColor / textColor /
    // activeTextColor 共 8 行。那是 Skote 模板 element-ui 菜单的遗留 —— side-bar.vue 的
    // menu 对象只有 isCollapse，模板也只读这一个，四个字段全仓库无人消费。侧栏配色实际来自
    // side-bar.vue 上的 `background-color: var(--sidebar-background)` 与 CSS 变量主题。
    // 留着只会让人以为改这里能改侧栏颜色，已删。
    let state = this.$store.state.layout;
    ProfileData.applyResolvedAppearance(state.theme === "dark" ? "dark" : "light");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");
      if (window.screen.width < 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach(() => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
        return;
      }
      this.$refs.sideBar.menu.isCollapse = !this.$refs.sideBar.menu.isCollapse;
      document.body.classList.toggle("vertical-collpsed");
    },
    toggleRightSidebar() {
      this.$refs.rightBar.visible = true;
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar v-if="!this.hideLayout"/>
    <!--      <SideBar ref="sideBar" :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth"/>-->
    <SideBar v-if="!this.hideLayout" ref="sideBar" :type="leftSidebarType"/>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="main-content" :style="this.hideLayout ? { marginLeft: '0px' } : {}">
      <div class="page-content">
        <div class="view">
          <router-view/>
        </div>
      </div>
      <Footer v-if="!this.hideLayout"/>
    </div>
    <RightBar ref="rightBar"/>
  </div>
</template>

<style scoped>
.page-content {
  display: flex;
  justify-content: center;
}

.view {
  width: 100%;
  max-width: 1200px;
}
</style>
